import { render, staticRenderFns } from "./ProductItemSelect.vue?vue&type=template&id=eabadf62&"
import script from "./ProductItemSelect.vue?vue&type=script&lang=js&"
export * from "./ProductItemSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports